import React, { FC, useState } from 'react';
import BillFilter from './Filter';
import BillDownloadTable from './List';
import usePagination from '../../../shared/hooks/usePagination';
import { getUnblockLoyaltyReportDownload } from '../../../services/TenantReports/UnblockLoyaltyReport.service';

const UnblockLoyaltyReport: FC = () => {
  const [refreshView, setRefreshView] = useState<string>('');
  const {
    data,
    isLoading,
    page,
    offset,
    setPage,
    setOffset
  } = usePagination(getUnblockLoyaltyReportDownload, [refreshView]);
  return (
    <div>
      <BillFilter setRefreshView={setRefreshView} />
      <BillDownloadTable
        reports={data || []}
        isLoading={isLoading}
        page={page}
        offset={offset}
        setPage={setPage}
        setOffset={setOffset}
      />
    </div>
  );
};

export default UnblockLoyaltyReport;
